import { render } from "./FormGPR.vue?vue&type=template&id=9c88ba5a&scoped=true"
import script from "./FormGPR.vue?vue&type=script&lang=js"
export * from "./FormGPR.vue?vue&type=script&lang=js"

import "./FormGPR.vue?vue&type=style&index=0&id=9c88ba5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c88ba5a"]])

export default __exports__